export class JobDetailsDTO {
    id: number;
    externalTitle: string;
    responsibilities: JobDetailsResponsibilityDTO[];
    address: string;
    city: string;
    country: string;
    externalDescription: string;
    state: string;
    postalCode: string;
    percentageMatch: number;
    category: string;
    ext_PostingDate: Date;
    travelTime: string;
    videoURL: string;
    requisitionWorkLocations: RequisitionWorkLocationDTO[];
    checked = false;
    applicationId: number;
    isDrafted: boolean;
    candidateStatus: string;
    isApplied: boolean;
    isClosed: boolean;
    isFavorite: boolean;
    requisitionCode: string;
}
export class JobDetailsResponsibilityDTO {
    responsibilityText: string;
}
export class RequisitionWorkLocationDTO {
    address1: string;
    address2: string;
    city: string;
    state: string;
    country: string;
    postalCode: string;
    latitude: any;
    longitude: any;
    locationDisttance: any;
    busTravelTime: any;
    carTravelTime: any;
}



// WEBPACK FOOTER //
// ../UI/src/app/shared/job/job-details.dto.ts